import React from 'react';
import { connect } from 'react-redux';
import Formsy from 'formsy-react';
import { Grid, Button } from '@mui/material';
import SelectInput from 'components/inputs/SelectInput';
import renderInput from 'utils/inputRenderer';

export default class DetailsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      customFields: props.formData?.fields || {},
      merchantID: null
    }

    this.updateMerchantID = this.updateMerchantID.bind(this);
  }

  componentDidMount() {
    const { promotion, updateProductId } = this.props;
    if (promotion.products && promotion.products.length === 1) {
      updateProductId(promotion.products[0].value);
    }
  }

  shouldShowInput(field) {
    if (field.dependency_field_id) {
      if (!field.dependency_values.includes(this.state.customFields[field.dependency_field_id] || '0')) {
        return false;
      }
    }

    return true;
  }

  renderProductSelect() {
    const { promotion, formData } = this.props;

    if (promotion.products && promotion.products.length > 1) {
      return (
        <SelectInput name="product_id" label="Product" value={formData.product_id} placeholder="Select Product" required
          options={promotion.products}
          validationErrors={{isDefaultRequiredValue: "can't be blank"}}
        />
      );
    }
    return null;
  }

  updateMerchantID(id) {
    this.setState({merchantID: id});
  }

  render() {
    const { promotion, handleNext, formData, filenames, onFileChange } = this.props;

    const options = { onFileChange, updateMerchantID: this.updateMerchantID, merchantID: this.state.merchantID };

    return (
      <Formsy onValidSubmit={handleNext} onChange={(currentValues) => this.setState({customFields: currentValues})} noValidate>
        <Grid container spacing={1} justifyContent="center">
          <Grid size={{sm: 8, xs: 11}}>
            {this.renderProductSelect()}
            {promotion.form_schema.map((field, i) => (
              this.shouldShowInput(field) && renderInput(field, formData.fields[field.id], i, filenames, options)
            ))}
          </Grid>
        </Grid>
        <div className="button-container">
          <Button type="submit" variant="contained" color="primary">Next</Button>
        </div>
      </Formsy>
    )
  }
}
